module.exports = __webpack_public_path__ + "img/bg07.de5d1866.gif";